import { STEP_KEYS } from '../../../components/CreateListingPage/constants/stepKeys';
import { useOptionalWizardNavigation } from '../../../components/CreateListingPage/WizardNavigationProvider';

/**
 * True when the create-listing wizard is on the review step.
 * On review, multiplex session APIs are skipped and listing endpoints are used instead.
 */
export const useIsOnReviewStep = (): boolean => {
  const wizardNavigation = useOptionalWizardNavigation();

  return wizardNavigation?.currentStepKey === STEP_KEYS.REVIEW;
};
